import IndustryPlaceholderPage from "@/components/industry/IndustryPlaceholderPage";
import { Sparkles, Calculator, ClipboardList, FileText, Send, Palette, Users, BarChart3 } from "lucide-react";

const CleaningIndustry = () => {
  return (
    <IndustryPlaceholderPage
      name="Commercial Cleaning"
      icon={Sparkles}
      iconColor="text-info"
      iconBg="bg-[hsl(var(--info)/0.1)]"
      headline="Commercial Cleaning Proposals"
      tagline="in Minutes"
      description="Sentinel Forge helps janitorial and commercial cleaning companies create professional service proposals, calculate pricing, and close contracts faster than ever."
      benefits={[
        "Save Hours on Bids",
        "Win More Clients",
        "Built for Cleaning Companies",
      ]}
      valueProps={[
        { title: "Save Hours on Bids", description: "Auto-generate scope-of-work proposals based on facility type, square footage, and service frequency — no more manual spreadsheets." },
        { title: "Win More Clients", description: "Professional, branded proposals that stand out from competitors and build trust with property managers and facility directors." },
        { title: "Built for Cleaning Companies", description: "Industry-specific templates, terminology, and pricing models designed by professionals who understand commercial cleaning." },
      ]}
      features={[
        { icon: Calculator, label: "Pricing Calculators" },
        { icon: ClipboardList, label: "Scope-of-Work Builder" },
        { icon: FileText, label: "PDF Proposals" },
        { icon: Send, label: "Digital Contracts" },
        { icon: Palette, label: "Custom Branding" },
        { icon: Users, label: "Team Access" },
        { icon: BarChart3, label: "Proposal Tracking" },
        { icon: Sparkles, label: "Service Templates" },
      ]}
      proposalTemplates={[
        "Office Cleaning Proposal",
        "Medical Facility Sanitation",
        "Post-Construction Cleanup",
        "Floor Care & Maintenance",
        "Window Cleaning Services",
      ]}
      contractTemplates={[
        "Standard Janitorial Service Agreement",
        "Recurring Cleaning Contract",
        "Deep Clean One-Time Agreement",
        "Specialized Sanitation Contract",
      ]}
      faq={[
        { q: "What is Sentinel Forge for cleaning companies?", a: "Sentinel Forge is a proposal and contract automation platform. For cleaning companies, it lets you build professional service proposals with scope-of-work details, pricing breakdowns, and digital contracts — all from one dashboard." },
        { q: "Can I calculate pricing by square footage?", a: "Yes. The cleaning module includes pricing calculators that factor in square footage, service frequency, facility type, and labor rates to generate accurate quotes automatically." },
        { q: "Do I need technical experience?", a: "Not at all. The platform is designed for cleaning business owners and operations managers. Fill in your client details and the system builds the proposal for you." },
        { q: "Can I send contracts digitally?", a: "Yes. You can generate contracts from any proposal and send them to clients for digital signature — no printing, scanning, or mailing required." },
        { q: "Is there a free trial?", a: "Yes. The Starter plan includes a free 7-day trial so you can explore the platform before committing." },
        { q: "Can I add my company branding?", a: "Absolutely. You can add your company logo, colors, and custom terms to every proposal and contract you send." },
        { q: "What features require the Professional plan?", a: "Restroom charge calculations, add-on service pricing (window cleaning, carpet cleaning, etc.), and the contract generator all require the Professional plan or above." },
        { q: "How do I get support?", a: "You can reach our team at support@sentinelforge.com or through the in-app support system." },
      ]}
      ctaHeadline="Ready to modernize your cleaning bids?"
      ctaDescription="Join cleaning companies automating their proposals and contracts with Sentinel Forge."
    />
  );
};

export default CleaningIndustry;
